// remnants carry a traced outline — draw it so the shape is clear next to the photo
export const ShapePreview = ({ polygon, length, width, testId }) => {
  const pts = (polygon || [])
    .map((p) => [Number(p.x ?? p[0] ?? 0), Number(p.y ?? p[1] ?? 0)])
    .filter((p) => Number.isFinite(p[0]) && Number.isFinite(p[1]));
  if (pts.length < 3) return null;
  const L = Number(length) || 1;
  const W = Number(width) || 1;
  const H = Math.max(20, Math.min(100, (W / L) * 100));
  return (
    <div className="relative border-t border-zinc-800 bg-zinc-950 p-3">
      <span className="font-mono-data absolute right-3 top-3 text-[9px] uppercase tracking-widest text-zinc-600">
        Shape · {Math.round(L)}&quot; x {Math.round(W)}&quot;
      </span>
      <svg
        viewBox={`-6 -6 112 ${H + 12}`}
        preserveAspectRatio="xMidYMid meet"
        className="h-24 w-full"
        data-testid={testId || "portal-remnant-shape"}
      >
        <rect
          x="0"
          y="0"
          width="100"
          height={H}
          fill="none"
          stroke="#3f3f46"
          strokeWidth="0.7"
          strokeDasharray="3 2"
        />
        <polygon
          points={pts.map(([x, y]) => `${x * 100},${y * H}`).join(" ")}
          fill="rgba(99,102,241,0.22)"
          stroke="#818cf8"
          strokeWidth="1.4"
        />
      </svg>
    </div>
  );
};
